import {autoinject} from 'aurelia-framework';
import {timeout} from "rxjs/operators";
import {UrlState} from "../services/url-state";

@autoinject()
export class SmoothScrollCustomAttribute {
  constructor(private element: Element,
              private urlState: UrlState) { }

  attached(){
    this.element.addEventListener('click', (e, respond = null)=>{
      this.scroll(e, respond);
    });
  }

  valueChanged(newValue, oldValue) {
    //
  }

  scroll(e, respond = null){

    const distanceToTop = el => {
      return Math.floor(el.getBoundingClientRect().top);
    };

    e.preventDefault();
    let targetID = (respond) ? respond.getAttribute('href') : this.element.getAttribute('href');

    const targetAnchor = document.querySelector(targetID);
    if (!targetAnchor) return;
    this.urlState.hashChanged(null, targetID);
    const originalTop = distanceToTop(targetAnchor);
    setTimeout(() => {
      //window.scroll({top: originalTop, left: 0, behavior: 'smooth'});
    }, 300);


    const checkIfDone = setInterval(function(){
      const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
      if (distanceToTop(targetAnchor) === 0 || atBottom) {
        targetAnchor.tabIndex = '-1';
        targetAnchor.focus();
        window.history.pushState('','',targetID);
        clearInterval(checkIfDone);
      }
    }, 200);

  }
}
